import publication_card from './publication_card';
import './publication.css'

const getYearMonthValue = (yearMonth) => {
    const [year = '0', month = '0'] = String(yearMonth).split('.');
    return Number(year) * 100 + Number(month);
}

const publication = () => {
    const paperData = require('../../database/paper.json')
    const papersByYear = {};

    const sortedPapers = [...paperData['papers']].sort((a, b) => getYearMonthValue(b.year) - getYearMonthValue(a.year));

    sortedPapers.forEach(element => {
        const year = String(element.year).split('.')[0];
        if (!papersByYear[year]) {
            papersByYear[year] = [];
        }
        papersByYear[year].push(element);
    });

    const paperComponents = [];
    Object.keys(papersByYear)
        .sort((a, b) => Number(b) - Number(a))
        .forEach(year => {
            paperComponents.push(
                <div key={year} className='publication_year'>
                    <h3>{year}</h3>
                    {papersByYear[year].map((paper) => publication_card(paper))}
                </div>
            );
        });

    return (
        <section id='publication'>
            <h2>Selected Publications</h2>
            <div className='papers_container'>
                {paperComponents}
            </div>
        
        </section>
    )
}

export default publication
